document.addEventListener('DOMContentLoaded',()=>{
  const open=document.querySelector('.menu-toggle');
  const close=document.querySelector('.menu-close');
  const drawer=document.querySelector('.site-sidebar');
  const overlay=document.querySelector('.sidebar-overlay');
  const panels=[...document.querySelectorAll('[data-menu-panel]')];
  if(!open||!drawer||!overlay)return;
  const showPanel=(name)=>{
    panels.forEach(panel=>{panel.hidden=panel.dataset.menuPanel!==name});
    drawer.classList.toggle('submenu-view',name!=='main');
  };
  const setDrawer=(show)=>{
    open.setAttribute('aria-expanded',String(show));
    drawer.setAttribute('aria-hidden',String(!show));
    overlay.setAttribute('aria-hidden',String(!show));
    drawer.classList.toggle('open',show);
    overlay.classList.toggle('open',show);
    document.body.classList.toggle('drawer-open',show);
    if(!show)showPanel('main');
  };
  open.addEventListener('click',()=>setDrawer(true));
  close?.addEventListener('click',()=>setDrawer(false));
  overlay.addEventListener('click',()=>setDrawer(false));
  document.querySelector('.sidebar-shop-trigger')?.addEventListener('click',()=>showPanel('shop'));
  document.querySelector('.sidebar-services-trigger')?.addEventListener('click',()=>showPanel('services'));
  document.querySelectorAll('.sidebar-back').forEach(button=>button.addEventListener('click',()=>showPanel('main')));
  document.addEventListener('keydown',e=>{if(e.key==='Escape')setDrawer(false)});
});
